import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup } from 'ps-design';
import Input from '../../Input/Input';

export default class JobGrade extends Component {
  static propTypes = {
    addJob: PropTypes.object,
    saveJob: PropTypes.func,
    saveJobGrade: PropTypes.func,
    updatePayReport: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  };

  constructor(props) {
    super(props);
    this.state = {
      org_salary_grade: this.props.addJob.jobGrade
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.addJob.jobGrade !== this.props.addJob.jobGrade)
      this.setState({ org_salary_grade: nextProps.addJob.jobGrade });
  }

  handleGradeChange(event) {
    if (event && event.target) {
      this.setState({ org_salary_grade: event.target.value });
    } else {
      this.setState({ org_salary_grade: '' });
    }
  }

  handleGradeBlur() {
    if (this.state.org_salary_grade === this.props.addJob.jobGrade) {
      return;
    }

    this.props.saveJobGrade({ org_salary_grade: this.state.org_salary_grade });
  }

  render() {
    const { children } = this.props;
    return (
      <div className="row add-job__grade">
        <h3 className="add-job__all-headers">
          <i className="add-job__experience-heading-icon icon-chart-arrow" />
          Select a Job Grade
        </h3>

        <div className="col-sm-12 add-job__grade__form-container">
          <FormGroup
            text="Pay Structure"
            labelClassName="add-job__form-headers"
            className="add-job__grade__structure-list"
          >
            {children[0]}
          </FormGroup>
          <FormGroup text="Job Grade" labelClassName="add-job__form-headers" className="add-job__grade__inputs">
            <Input
              type="text"
              value={this.state.org_salary_grade}
              onChange={this.handleGradeChange.bind(this)}
              onBlur={this.handleGradeBlur.bind(this)}
              className="add-job__input add-job__input--grade"
            />
          </FormGroup>
          {children[1]}
        </div>
      </div>
    );
  }
}
